import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PostCard } from "../pages/Blog";
import { usePosts } from "../lib/content";

export const JournalTeaser = () => {
  const posts = usePosts();
  return (
  <section id="journal" data-testid="journal-teaser" className="bg-[#F6F2EC] py-24 sm:py-36 border-t border-[#ddd4c7]">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-8 mb-14 sm:mb-20">
        <div>
          <Reveal><p className="overline text-[#8A6A3A] mb-6">Journal</p></Reveal>
          <Reveal delay={0.05}><h2 className="font-serif-d font-light text-[2.6rem] sm:text-6xl leading-[1] text-[#14110F]">Dal blog di <em className="text-[#8A6A3A]">Gioia</em></h2></Reveal>
        </div>
        <Reveal delay={0.1}>
          <Link to="/blog" data-testid="journal-all-link" className="group inline-flex items-center gap-3 rounded-full border border-[#14110F] px-7 py-3.5 text-[0.72rem] tracking-[0.2em] uppercase text-[#14110F] transition-colors duration-500 hover:bg-[#14110F] hover:text-[#F6F2EC]">
            Tutti gli articoli <ArrowUpRight className="w-4 h-4 transition-transform duration-500 group-hover:rotate-45" />
          </Link>
        </Reveal>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
        {posts.slice(0, 3).map((p, i) => <PostCard key={p.slug} p={p} i={i} />)}
      </div>
    </div>
  </section>
  );
};
